import getString from "../../../../config/strings";
import LiveSentimentImage from "../../../../resources/LiveSentiment.png";
import SocialMentionsImage from "../../../../resources/SocialMentions.png";
import FinancialDataImage from "../../../../resources/FinancialData.jpg";
import LiveNewsImage from "../../../../resources/LiveNews.jpg";
export const featuresConfig = {
  [getString("LiveSentiment")]: {
    heading: getString("Home_LiveSentimentFeatureHeading"),
    text: getString("Home_LiveSentimentFeature"),
    image: LiveSentimentImage,
  },
  [getString("SocialMentions")]: {
    heading: getString("Home_SocialMentionsFeatureHeading"),
    text: getString("Home_SocialMentionsFeature"),
    image: SocialMentionsImage,
  },
  [getString("FinancialData")]: {
    heading: getString("Home_FinancialDataFeatureHeading"),
    text: getString("Home_FinancialDataFeature"),
    image: FinancialDataImage,
  },
  [getString("LiveNews")]: {
    heading: getString("Home_LiveNewsFeatureHeading"),
    text: getString("Home_LiveNewsFeature"),
    image: LiveNewsImage,
  },
};
